import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import {NavLink} from "react-router-dom";
import ListInfo from "../kozel/ListInfo";
import useTeaserGameStyle from "../../styles/kozelMeet/teaserGame";
import bottle_premium_chose from '../../assets/images/kozel_meet/bottle_premium_chose.png';
import bottle_dark_chose from '../../assets/images/kozel_meet/bottle_dark_chose.png';
import tap_in_circle from '../../assets/images/kozel_meet/tap_in_circle.png';
import icon_arrow from '../../assets/images/icon_arrow.png';
import clsx from "clsx";
import {useAppDispatch, useAppSelector} from "../../stores/store";
import {setOption} from "../../features/games/gameSlice";
import {paths} from "../../AppRouters";
import {gameNameApi} from "./BottleGame";

const TeaserGame: React.FC = () => {
    const styles = useTeaserGameStyle();
    const dispatch = useAppDispatch();
    const {games} = useAppSelector((state) => state.game);
    const {option} = games[gameNameApi];

    useEffect(() => {
        dispatch(setOption({
            gameName: gameNameApi,
            bottle: 'premium',
        }))
    }, [dispatch]);

    const handleClickBottle = (bottle: string) => {
        dispatch(setOption(
            {
                bottle: bottle
            }
        ))
    }

    return (
        <Grid container className={styles.containerTeaserGame}>
            <Grid item xs={12} className={styles.itemTeaserGame}>
                <TeaserFrame2
                    title={<Typography className={styles.teaserTitle}>Spin the bottle <br/><span
                        className={'underTitle'}>and accept the challenge!</span></Typography>}
                    titleMarginTop={'min(-3vh,-3vw)'}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                    colorBorderDotted={theme.colors.desert_sand_gold}
                >
                    <Grid container className={styles.containerContent}>
                        <Grid item xs={12} className={styles.containerItemContent}>
                            <Typography className={styles.subtitleContent}>Ideally, it is played in 3 or more
                                :)</Typography>
                            <Typography className={styles.subtitleContent}> You don’t have your team formed yet? Invite your friends <NavLink
                                    to={paths.myGroup}>here.</NavLink> </Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.containerItemContent}>
                            <Grid container className={styles.containerTapZone}>
                                <Grid item lg={4} xs={12} className={styles.boxImgTap}>
                                    <img src={tap_in_circle} alt={'tap_in_circle'} className={styles.imgTap}/>
                                </Grid>
                                <Grid item lg={8} xs={12} className={styles.boxTapMessage}>
                                    <Typography className={styles.tapMessage}>p.s. If you want to play anyway, do it. OLDA is 
eager to challenge you!</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={styles.containerItemContent}>
                            <Grid container className={styles.containerSection}>
                                <Grid item lg={4}
                                      className={clsx(styles.containerSectionItem, styles.containerSectionItemColumn)}>
                                    <Typography className={styles.titleContent}>HOW TO PLAY:</Typography>
                                    <img src={icon_arrow} alt={'icon_arrow'} className={styles.arrowImg}/>
                                </Grid>
                                <Grid item lg={8} className={styles.containerSectionItem}>
                                    <ListInfo hasContrast={true} items={[
                                        {
                                            text: "You form your team (if you don't have a team now, you can play with OLDA)",
                                        },
                                        {
                                            text: 'you choose the Kozel bottle which you want to spin first (tip: choose both, successively; you will see that they spin just as easily!)',
                                        },
                                        {
                                            text: 'select start game',
                                        },
                                        {
                                            text: 'challenge your friends',
                                        },
                                        {
                                            text: 'be challenged in return',
                                        },
                                        {
                                            text: 'make sure the challenges are respected :)',
                                        },
                                        {
                                            text: 'earn points and turn them for beer at UNTOLD',
                                        },
                                    ]}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={clsx(styles.containerItemContent, styles.borderDottedTop)}>
                            <Grid container className={styles.containerSection}>
                                <Grid item xs={12} className={styles.containerSectionItem}>
                                    <Typography className={styles.titleContent2}>Choose your Kozel bottle</Typography>
                                </Grid>
                                <Grid item xs={12}
                                      className={clsx(styles.containerSectionItem, styles.boxItemBottleChose)}>
                                    <img src={bottle_premium_chose} alt={'bottle_premium_chose'}
                                         className={clsx(styles.imgBottlePremium, (option && option.bottle === 'dark') ? '' : 'selected')}
                                         onClick={() => handleClickBottle('premium')}/>
                                    <img src={bottle_dark_chose} alt={'bottle_dark_chose'}
                                         className={clsx(styles.imgBottleDark, (option && option.bottle === 'dark') ? 'selected' : '')}
                                         onClick={() => handleClickBottle('dark')}/>
                                </Grid>
                                <Grid item xs={12} className={styles.containerSectionItem}>
                                    <NavLink to={paths.gameRollBottle} className={styles.buttonCta}>Start game</NavLink>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
        </Grid>
    )
}

export default TeaserGame;